import React, { useEffect } from 'react';
import useStorage from '../hooks/useStorage';


const ProgressBar = ({file, setFile, genre, setImgUrl}) => {
    const {url, progress} = useStorage(file, genre);
    
    useEffect(() => {
        if (url){
            setImgUrl(url);
            setFile(null);
        }
    }, [url, setFile, setImgUrl])

    return (
        <div>
            Image
            <div className="progress-bar" style={{"border": "1px solid black", "backgroundColor": "white", "height": "15px"}}>
                <div style={{"width": progress + '%', "height": "100%", "backgroundColor": "#90be4e"}}>
                    <p style={{"textAlign": "center", "color": "black", "fontSize": "15px"}}>{Math.floor(progress)}</p>
                </div>
            </div>
            <br />
        </div>
    );
}


export default ProgressBar;